import { render, staticRenderFns } from "./Restaurant_Orden2.vue?vue&type=template&id=56c12ded&"
import script from "./Restaurant_Orden2.vue?vue&type=script&lang=js&"
export * from "./Restaurant_Orden2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports